import React from "react";
import { IconProps } from "../type";

export function Whatsapp({
  color = "currentColor",
  size = 24,
  className = "",
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5107_977)">
        <path
          d="M12.003 0.976562H11.997C5.3805 0.976562 0 6.35856 0 12.9766C0 15.6016 0.846 18.0346 2.2845 20.0101L0.789 24.4681L5.4015 22.9936C7.299 24.2506 9.5625 24.9766 12.003 24.9766C18.6195 24.9766 24 19.5931 24 12.9766C24 6.36006 18.6195 0.976562 12.003 0.976562ZM18.9855 17.9221C18.696 18.7396 17.547 19.4176 16.6305 19.6156C16.0035 19.7491 15.1845 19.8556 12.4275 18.7126C8.901 17.2516 6.63 13.6681 6.453 13.4356C6.2835 13.2031 5.028 11.5381 5.028 9.81606C5.028 8.09406 5.9025 7.25556 6.255 6.89556C6.5445 6.60006 7.023 6.46506 7.482 6.46506C7.6305 6.46506 7.764 6.47256 7.884 6.47856C8.2365 6.49356 8.4135 6.51456 8.646 7.07106C8.9355 7.76856 9.6405 9.49056 9.7245 9.66756C9.81 9.84456 9.8955 10.0846 9.7755 10.3171C9.663 10.5571 9.564 10.6636 9.387 10.8676C9.21 11.0716 9.042 11.2276 8.865 11.4466C8.703 11.6371 8.52 11.8411 8.724 12.1936C8.928 12.5386 9.633 13.6891 10.671 14.6131C12.0105 15.8056 13.0965 16.1866 13.485 16.3486C13.7745 16.4686 14.1195 16.4401 14.331 16.2151C14.5995 15.9256 14.931 15.4456 15.2685 14.9731C15.5085 14.6341 15.8115 14.5921 16.1295 14.7121C16.4535 14.8246 18.168 15.6721 18.5205 15.8476C18.873 16.0246 19.1055 16.1086 19.191 16.2571C19.275 16.4056 19.275 17.1031 18.9855 17.9221Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5107_977">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
